import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import adminActions from '../../../../actions/adminActions';

function getPermitType(permitTypes, permitTypeId) {
  return permitTypes.find((permitType) => permitType.id === permitTypeId);
}

function getTerritoryName(territoryId, territories) {
  return territories.find((territory) => territory.id === territoryId)?.name;
}

const CombinationAssignmentsPanel = ({ user, permitTypes, territories }) => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);

  const handleAccordionChange = (permitType) => (event, isExpanded) => {
    setExpanded(isExpanded ? permitType : false);
  };

  const groupedCombinations = user.assignedPermitTypeLocations?.reduce((acc, combo) => {
    if (!acc[combo.permitTypeId]) {
      acc[combo.permitTypeId] = [];
    }
    acc[combo.permitTypeId].push(combo.territoryId);
    return acc;
  }, {});

  return (
    <Box>
      <Typography variant="h6">Assignments</Typography>
      {groupedCombinations &&
        Object.keys(groupedCombinations).map((permitTypeIdKey) => {
          const permitTypeId = parseInt(permitTypeIdKey, 10);
          return (
            <Accordion
              key={permitTypeId}
              expanded={expanded === permitTypeId}
              onChange={handleAccordionChange(permitTypeId)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: '#a5d33a',
                  color: 'black',
                }}
              >
                <Typography>{`${getPermitType(permitTypes, permitTypeId)?.name} (${
                  groupedCombinations[permitTypeId].length
                })`}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ backgroundColor: '#e9ecef' }}>
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<RemoveCircleOutlineIcon />}
                  onClick={() => {
                    dispatch(
                      adminActions.unassignPermitTypeLocations(
                        user.id,
                        groupedCombinations[permitTypeId].map((territoryId) => ({
                          permitTypeId,
                          territoryId,
                        }))
                      )
                    );
                  }}
                >
                  Unassign All
                </Button>
                <List>
                  {groupedCombinations[permitTypeId].map((territoryId, index) => (
                    <ListItem
                      key={index}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          onClick={() => {
                            dispatch(
                              adminActions.unassignPermitTypeLocations(user.id, [
                                { permitTypeId, territoryId },
                              ])
                            );
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      }
                    >
                      <ListItemText primary={getTerritoryName(territoryId, territories)} />
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          );
        })}
    </Box>
  );
};

CombinationAssignmentsPanel.propTypes = {
  user: PropTypes.object.isRequired,
  permitTypes: PropTypes.array.isRequired,
  territories: PropTypes.array.isRequired,
};

export default CombinationAssignmentsPanel;
